module.exports = "<p>\r\n  asset works!\r\n</p>\r\n"